import { Component } from '@angular/core';
import { SubHeaderService } from '../../store/subheader/subheader.service';

@Component({
    selector: 'app-document-subheader',
    templateUrl: './document-subheader.component.html',
    styleUrls: ['./document-subheader.component.scss'],
    standalone: false
})
export class DocumentSubheaderComponent {
  constructor(private readonly subHeaderService: SubHeaderService) {}

  ngOnInit(): void {}

  triggerAction(actionName) {
    this.subHeaderService.setTriggerAction(actionName);
  }
}
